module.exports = __webpack_public_path__ + "components/country-flag/static/gb-sct-e16d41f6fbd60f0fe5c9a1496d8e1775.svg";